import type { App } from "vue";

const dynamicEntryLayoutWarnings = [
  // Our dynamic entry layout has props drilled into it that
  // are not always applicable. Let's avoid spamming warnings
  // in dev mode for this as it's inconsequential.
  "at <AsyncComponentWrapper>",
  "at <DynamicEntryLayout>",
  // When adding a data-testid attribute to a typical Radix component, we get a warning
  // saying "Extraneous non-props attributes (data-testid) were passed to component..."
  "Extraneous non-props attributes (data-testid)",
];

const warningsToIgnore = [...dynamicEntryLayoutWarnings];

export default function customWarnHandler(app: App) {
  // eslint-disable-next-line no-param-reassign
  app.config.warnHandler = (msg, vm, trace) => {
    if (
      warningsToIgnore.some(
        (ignored) => trace.includes(ignored) || msg.includes(ignored)
      )
    ) {
      return;
    }

    console.warn(`${msg}\n${trace}`, vm);
  };
}
